function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { call, delay, getContext } from 'redux-saga/effects';
import { LocalError } from 'helpers/errorTypes';
import ApiService from 'services/ApiService';
function* fetchExchangeToken(authorizationCode, scope, controlId) {
    if (!process.env.BROWSER) {
        return null;
    }
    const { code, storageProvider } = authorizationCode;
    const domain = yield getContext('domain');
    const getUrl = yield getContext('getUrl');
    let redirectUrl = '';
    switch(storageProvider){
        case 'CentralStorage':
            {
                yield delay(150);
                break;
            }
        case 'GoogleDrive':
            {
                redirectUrl = `${domain}${getUrl('google-drive')}`;
                break;
            }
        default:
            {
                throw new LocalError({
                    code: 'UnknownStorageProvider'
                });
            }
    }
    const requestUrl = '/api/StorageTokensNew/ExchangeToken';
    const tokens = yield call(ApiService.regionalRequest, requestUrl, {
        method: 'POST',
        body: {
            storageProvider,
            authorizationCode: code,
            redirectUrl,
            scope,
            controlId
        }
    });
    return _object_spread_props(_object_spread({}, tokens), {
        storageProvider
    });
}
function* assignExchangeToken(exchangeToken, scope, controlId) {
    if (!process.env.BROWSER) {
        return null;
    }
    const requestUrl = '/api/StorageTokensNew/AssignExchangeToken';
    return yield call(ApiService.regionalRequest, requestUrl, {
        method: 'POST',
        body: {
            exchangeToken,
            scope,
            controlId
        }
    });
}
function* fetchAccessToken(exchangeToken) {
    const requestUrl = '/api/StorageTokensNew/AccessToken';
    return yield call(ApiService.regionalRequest, requestUrl, {
        method: 'POST',
        body: {
            exchangeToken
        }
    });
}
function* revokeExchangeToken(exchangeToken) {
    yield call(ApiService.regionalRequest, '/api/StorageTokensNew/ExchangeToken', {
        method: 'DELETE',
        body: {
            exchangeToken
        }
    });
}
export default {
    fetchExchangeToken,
    assignExchangeToken,
    fetchAccessToken,
    revokeExchangeToken
};
